import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

type ModalProps = React.ComponentProps<typeof Modal>

const DashboardEditVariablesModal = ({
  onClose,
  onSubmit,
  submitDisabled,
  children,
}: {
  onClose: ModalProps['onClose']
  onSubmit: ModalProps['onSubmit']
  submitDisabled: boolean
  children: React.ReactNode
}) => {
  return (
    <Modal
      illustration="documents"
      title={i18n.t('custom_reports.add_filter')}
      description={i18n.t('custom_reports.configure_filter')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={() => onClose && onClose()}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={submitDisabled} submit>
            {i18n.t('common.edit')}
          </Button>
        </>
      }
    >
      {children}
    </Modal>
  )
}

export default observer(DashboardEditVariablesModal)
